import { render, staticRenderFns } from "./CancelButton.vue?vue&type=template&id=84468b6e&scoped=true&"
import script from "./CancelButton.vue?vue&type=script&lang=ts&"
export * from "./CancelButton.vue?vue&type=script&lang=ts&"
import style0 from "./CancelButton.vue?vue&type=style&index=0&id=84468b6e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84468b6e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/builds/3ce44491/2/fsi-lab/soft/app/robot-config/frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
installComponents(component, {VBtn})
